'use client';
import React from 'react';

import WildsLaunchContainer from '@components-launch/Wilds/WildsLaunchContainer';
import SpecificationTabData from '../../SpecificationTabData';

export default function Sustainability(props: any) {
  const [isMounted, setIsMounted] = React.useState(false);
  const { t } = props;

  React.useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) return;

  const tabContent = [
    {
      heading: t['sustainabilityContent']['title'],
      description: t['sustainabilityContent']['desc'],
      listElement: t['sustainabilityContent']['list'],
      images: props.tabImages,
    },
  ];

  return (
    <WildsLaunchContainer>
      <SpecificationTabData
        t={t}
        tabs={tabContent}
        tabThemeImageBackground={props.tabThemeImageBackground}
      />
    </WildsLaunchContainer>
  );
}
